module.exports = "/_next/static/images/hello-b76f9879a2f859c0871d1486b0b397fa.svg";